





















import { Vue, Component } from 'vue-property-decorator';
import { getBaseInfo } from './api';
import { isWeiXin, isMobile } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';

const baseUrl = '/1209XQD';
// let noticeAreaScrollTimer: any = null;
// let timerRight: any = null;

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  activeTab = 0;
  baseInfo: any = {};
  tabbars = [
    {
      title: 'e起留言',
      id: 1,
      path: baseUrl + '/home',
    },
    {
      title: '大咖建言',
      id: 2,
      path: baseUrl + '/known-people',
    },
    {
      title: '回复来了',
      id: 3,
      path: baseUrl + '/come',
    },
    {
      title: '媒体聚焦',
      id: 4,
      path: baseUrl + '/media-focus',
    },
  ];

  beforeRouteEnter(to: any, from: any, next: any) {
    if (!isMobile()) {
      return (location.href =
        'https://activity.cqcb.com/shangyou_activity/2022myExpect');
    }
    // 微信授权登录
    const { code } = to.query;
    const unionid = localStorage.getItem('unionid');
    if (isWeiXin() && !code && !unionid) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    } else {
      next();
    }
  }

  async created() {
    // app环境中重新获取用户信息
    if (window.udid) {
      window.userInfoChange = () => {
        location.reload();
      };
    }
    // const ret = await getBaseInfo();
    // console.log('base info is:', ret);
    // 处理tabbar高亮
    const index = this.tabbars.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '@所有人 展望2022，你有什么新期待？',
      url: location.href,
      subtitle:
        '新年你有哪些愿望？你对重庆重庆发展怎样的期盼？请你记录心愿、建言发展。',
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '@所有人 展望2022，你有什么新期待？',
        subtitle:
          '新年你有哪些愿望？你对重庆重庆发展怎样的期盼？请你记录心愿、建言发展。',
        image: cover,
      });
    }
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }

  mounted() {
    // this.onNoticeAreaScroll();
  }
  // onNoticeAreaScroll() {
  //   const noticeAreaEl = this.$refs.noticeArea as HTMLDivElement;
  //   noticeAreaEl.innerHTML += noticeAreaEl.innerHTML;
  //   // return;
  //   noticeAreaScrollTimer = setInterval(() => {
  //     noticeAreaEl.scrollLeft += 1;
  //     // console.log('L', noticeAreaEl.scrollLeft);
  //     if (
  //       Math.floor(noticeAreaEl.scrollLeft) ===
  //       Math.floor(noticeAreaEl.scrollWidth / 2)
  //     ) {
  //       noticeAreaEl.scrollLeft = 0;
  //     }
  //   }, 50);
  // }
}
